(function () {
  // Removes only the retired May-June 2026 free next-day slot copy. The live paid
  // "Tracked Next Day Delivery*" option copy (cart panel, rate estimator) must survive.
  var alwaysRemovePattern = /Next-Day Delivery Slot|Free Delivery Tomorrow|Keep This Slot/i;
  var standalonePromisePattern = /\b(?:in\s*)?(?:1|one)\s+(?:business|working)\s+day\b/ig;
  var standalonePromiseTestPattern = /\b(?:in\s*)?(?:1|one)\s+(?:business|working)\s+day\b/i;
  var bloomBustPromisePattern = /Bloom or Bust:\s*replacement or credit promise/ig;
  var bloomBustPromiseTestPattern = /Bloom or Bust:\s*replacement or credit promise/i;
  var cartSurfaceSelector = [
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    '.mini-cart',
    '.minicart',
    'form[action*="/cart"]'
  ].join(',');
  var cartSurfacePattern = /cart|drawer|minicart|mini-cart|cart-noti/i;
  var maxBlockTextLength = 900;
  var scheduled = false;
  var pendingRoot = null;
  var isProductPage = /\/products\//i.test(window.location.pathname);
  var isCartPage = /\/cart\/?$/i.test(window.location.pathname);

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function toElement(root) {
    if (!root || root === document) return document;
    return root.nodeType === 3 ? root.parentElement : root;
  }

  function matches(element, selector) {
    return Boolean(element && element.matches && element.matches(selector));
  }

  function getCartRoots(root) {
    var scope = toElement(root);
    var roots = [];

    if (isCartPage) {
      roots.push(document);
    }

    if (scope !== document && matches(scope, cartSurfaceSelector)) {
      roots.push(scope);
    }

    if (scope !== document && scope.closest) {
      var closest = scope.closest(cartSurfaceSelector);
      if (closest) roots.push(closest);
    }

    if (scope && scope.querySelectorAll) {
      Array.prototype.push.apply(roots, scope.querySelectorAll(cartSurfaceSelector));
    }

    return roots.filter(function (rootNode, index) {
      return rootNode && roots.indexOf(rootNode) === index;
    });
  }

  function isCartSurface(element) {
    if (isCartPage) return true;
    if (!element || element === document.body) return false;

    var descriptor = [
      element.id,
      element.className,
      element.getAttribute && element.getAttribute('data-section-type'),
      element.getAttribute && element.getAttribute('data-section-id')
    ].join(' ');

    return cartSurfacePattern.test(descriptor) || Boolean(element.closest && element.closest(cartSurfaceSelector));
  }

  function shouldStopClimbing(element) {
    if (!element || !element.parentElement) return true;
    if (element.parentElement === document.body || element.parentElement.tagName === 'MAIN') return true;
    if (/^(FORM|TABLE|TBODY|TR|UL|OL)$/i.test(element.parentElement.tagName)) return true;
    if (
      element.parentElement.querySelector('form[action*="/cart"], table, .cart-item, [id*="CartItem"], [class*="cart-item"]') &&
      !element.querySelector('form[action*="/cart"], table, .cart-item, [id*="CartItem"], [class*="cart-item"]')
    ) {
      return true;
    }
    return false;
  }

  function textLooksRestricted(text) {
    return alwaysRemovePattern.test(text);
  }

  function smallestOldDeliveryBlock(element) {
    var target = element;

    while (!shouldStopClimbing(target)) {
      var parentText = textOf(target.parentElement);
      if (!textLooksRestricted(parentText) || parentText.length > maxBlockTextLength) break;
      target = target.parentElement;
    }

    return target;
  }

  function tidyPromiseText(text) {
    return text
      .replace(standalonePromisePattern, '')
      .replace(/\s+([,.;:)])/g, '$1')
      .replace(/(\()\s+/g, '$1')
      .replace(/\(\s*\)/g, '')
      .replace(/\s*[-\u2013\u2014]\s*$/g, '')
      .replace(/[ \t]{2,}/g, ' ')
      .trim();
  }

  function textWalker(scope, testPattern, callback) {
    if (!scope || !document.createTreeWalker) return;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.nodeValue && testPattern.test(node.nodeValue)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(callback);
  }

  function stripStandalonePromiseText(root) {
    getCartRoots(root).forEach(function (cartRoot) {
      textWalker(cartRoot, standalonePromiseTestPattern, function (textNode) {
        textNode.nodeValue = tidyPromiseText(textNode.nodeValue);
      });
    });
  }

  function normalizeBloomBustPromiseText(root) {
    if (!isProductPage) return;

    var scope = root && root.querySelectorAll ? root : document.querySelector('main') || document;
    textWalker(scope, bloomBustPromiseTestPattern, function (textNode) {
      textNode.nodeValue = textNode.nodeValue.replace(bloomBustPromisePattern, 'Bloom or Bust Guarantee');
    });
  }

  function cleanupCartBlocks(root) {
    getCartRoots(root).forEach(function (cartRoot) {
      var nodes = cartRoot.querySelectorAll
        ? cartRoot.querySelectorAll('*:not(script):not(style)')
        : [];

      Array.prototype.forEach.call(nodes, function (node) {
        if (!node.isConnected) return;
        if (!textLooksRestricted(textOf(node))) return;
        if (Array.prototype.some.call(node.children, function (child) { return textLooksRestricted(textOf(child)); })) return;
        if (!isCartSurface(node)) return;

        var block = smallestOldDeliveryBlock(node);
        if (block && block.parentElement) {
          block.parentElement.removeChild(block);
        }
      });
    });
  }

  function cleanup(root) {
    if (!document.body) return;

    normalizeBloomBustPromiseText(root);
    stripStandalonePromiseText(root);
    cleanupCartBlocks(root);
  }

  function scheduleCleanup(root) {
    pendingRoot = pendingRoot === document || root === document ? document : (root || pendingRoot);
    if (scheduled) return;

    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      var root = pendingRoot || document;
      pendingRoot = null;
      cleanup(root);
    }, 80);
  }

  function startCleanup() {
    cleanup(document);

    var observer = new MutationObserver(function (mutations) {
      for (var index = 0; index < mutations.length; index += 1) {
        var target = mutations[index].target;
        if (isProductPage || getCartRoots(target).length > 0) {
          scheduleCleanup(target);
          break;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCleanup);
  } else {
    startCleanup();
  }
})();
